import { Controller } from "@hotwired/stimulus"

// Instagram投稿のフル画像を oEmbed の埋め込みウィジェットでモーダル表示する
// - ボタンクリックで dialog を開き、turbo-frame を遅延ロード
// - frame ロード完了で embed.js を読み込み instgrm.Embeds.process() を実行
export default class extends Controller {
  static targets = ["dialog", "frame"]
  static values = { src: String }

  open() {
    // 未ロードの場合のみ src をセット（再オープン時の再取得を防ぐ）
    if (this.frameTarget.getAttribute("src") !== this.srcValue) {
      this.frameTarget.setAttribute("src", this.srcValue)
    }
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  // turbo:frame-load から呼ばれる
  processEmbed() {
    this.loadScript().then(() => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process()
      }
    })
  }

  loadScript() {
    if (window.instgrm && window.instgrm.Embeds) return Promise.resolve()
    if (window.__instagramEmbedScriptPromise) return window.__instagramEmbedScriptPromise

    window.__instagramEmbedScriptPromise = new Promise((resolve) => {
      const script = document.createElement("script")
      script.src = "https://www.instagram.com/embed.js"
      script.async = true
      script.onload = () => resolve()
      script.onerror = () => resolve()
      document.body.appendChild(script)
    })
    return window.__instagramEmbedScriptPromise
  }
}
